import { apiInstance } from 'api/utils';

const providerPlatformChargesApi = {
  getProviderPlatformCharges: () => {
    return apiInstance.request({
      method: 'GET',
      url: `provider/sources/provider-platform-charges/`
    });
  },
  addProviderPlatformCharge: (data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `provider/sources/provider-platform-charges/`,
      data
    });
  },
  deleteProviderPlatformCharge: (id: number) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `provider/sources/provider-platform-charges/`,
      data: {
        id
      }
    });
  },
  discountCharges: (data: any, caseId: string, policyId: string) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/cases/${caseId}/policies/${policyId}/discount/`,
      data
    });
  }
};

export default { providerPlatformChargesApi };
